import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type TooltipProps = {
    text?: string;
    icon?: string | undefined;
    colour?: string | undefined;
    size?: number;
    placement: "left" | "right" | "top" | "bottom";
    [key: string]: any,
    classes?: string[]
}
export function TooltipIcon({ text, icon, placement, colour, size, classes }: TooltipProps) {
    return (
        <div className="ps-1 d-inline-grid tooltip-icon">
            <OverlayTrigger
                placement={placement}
                overlay={text ? <Tooltip id="tooltip-bottom" style={{position:"fixed"}}>{text}</Tooltip> : <></>}
            >
                <i style={{color: colour ? colour : "", fontSize: size ? `${size}px` : ""}} className={classNames( icon ? icon : "mdi mdi-information", "float-end", "d-flex", "justify-content-end", "align-items-center", classes ? classes : [])}  ></i>
            </OverlayTrigger>
        </div>
    );
}